import storage from '@/utils/storage';

import { convertArrayOfObjectToHashTable } from '@/utils/arrayToHashTable';

export default class ColumnsStorage {
  constructor({ columns, keyToStoreWith }) {
    this.columns = columns;
    this.key = keyToStoreWith;
    this.dynamicColumnsHashTable = convertArrayOfObjectToHashTable(
      columns,
      ({ property }) => property,
    );
    this.defaultVisibleColumns = this.columns.filter(
      col => !col.isHiddenDefault,
    );
  }
  _mapProperty(columns) {
    return columns.map(({ property }) => property);
  }
  _unMapProperty(columns) {
    return columns.map(property => this.dynamicColumnsHashTable[property]);
  }
  _validateColumnsByProperties(columnsProperties) {
    return columnsProperties.filter(
      property => property in this.dynamicColumnsHashTable,
    );
  }
  getVisibleColumns() {
    const storageColumns = storage.readJSON(this.key);
    return storageColumns
      ? this._unMapProperty(this._validateColumnsByProperties(storageColumns))
      : this.defaultVisibleColumns;
  }
  setVisibleColumns(visibleColumns) {
    const visibleColumnsProperties = this._mapProperty(visibleColumns);
    storage.writeJSON(
      this.key,
      this._validateColumnsByProperties(visibleColumnsProperties),
    );
  }
  getHiddenColumns() {
    const visibleColumns = this.getVisibleColumns();
    const visibleColumnsHashTable = convertArrayOfObjectToHashTable(
      visibleColumns,
      ({ property }) => property,
    );
    return this.columns.filter(
      ({ property }) => !(property in visibleColumnsHashTable),
    );
  }
}
